import { render, staticRenderFns } from "./WavegliderDashboardWidget.vue?vue&type=template&id=7c352e5c&scoped=true"
import script from "./WavegliderDashboardWidget.vue?vue&type=script&lang=js"
export * from "./WavegliderDashboardWidget.vue?vue&type=script&lang=js"
import style0 from "./WavegliderDashboardWidget.vue?vue&type=style&index=0&id=7c352e5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c352e5c",
  null
  
)

export default component.exports